import Box, { type BoxProps } from "@mui/material/Box";
import { forwardRef } from "react";

import { type ProblematicMuiPackagingProps } from "../Mui/types";

export type SpanProps = Omit<ProblematicMuiPackagingProps<BoxProps>, "component">;

/**
 * @deprecated Use the Text component from cbh-mobile-app's redesign system (ui-components has been removed from cbh-core) with inline=true for inline text.
 * If you need a generic inline wrapper, use Box with component="span" instead.
 * This component is a legacy artifact that encourages direct span usage which is undesired.
 */
export const Span = forwardRef((props: SpanProps, ref) => (
  <Box component="span" {...props} ref={ref} />
));

Span.displayName = "Span";
